import { useItemEdit } from "lib/hooks/useItemEdit";
import { GenericDialog } from "components/common/dialogs/GenericDialog";
import { useLocale } from "lib/hooks/useLocale";
import { DialogBody, DialogFooter } from "components/common/dialogs/GenericDialog";
import PrimaryButton from "components/common/buttons/PrimaryButton";
import CheckoutItems from "components/checkout/CheckoutItems";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { redirectUrl } from "lib/utils/helpers";
import { useMerchantContext } from "lib/contexts/MerchantProvider";
import { useOrderSummary } from "lib/hooks/useOrderSummary";
import { useUserContext } from "lib/contexts/UserProvider";
import { OrderSummaryErrorCustom } from "components/error-handling/OrderSummaryError";
import { useMemo } from "react";

export const UnservicableProductDialog = () => {
  const { t } = useLocale();
  const {
    state: { checkoutModal },
    actions: { setCheckoutModal, setCheckoutView },
  } = useCheckoutContext();
  const {
    state: { user },
  } = useUserContext();

  const {
    state: { merchant },
  } = useMerchantContext();

  const { unservicableItems, servicableItems } = useOrderSummary();
  const { handleItemEdit, isLoading } = useItemEdit();

  const areAllProductsUnservicable = servicableItems.length === 0;

  const errorTitle = useMemo(() => {
    return unservicableItems.length === 1
      ? t("item_unservicable_on_pincode_one", {
          count: unservicableItems.length,
          pincode: user?.default_shipping_address?.zip,
        })
      : t("item_unservicable_on_pincode_other", {
          count: unservicableItems.length,
          pincode: user?.default_shipping_address?.zip,
        });
  }, [unservicableItems]);

  const handleRemoveUnservicableItems = async () => {
    if (areAllProductsUnservicable) {
      handleGoBackToStore();
    } else {
      await handleItemEdit("delete", {
        itemIds: unservicableItems.map((item) => item.item_id),
      });
    }
  };

  const handleGoBackToStore = () => {
    if (merchant?.brandUrl) {
      redirectUrl(merchant.brandUrl);
    }
    setCheckoutModal("NONE");
    setCheckoutView("ADDRESS_LIST");
  };

  if (!unservicableItems.length) return null;
  return (
    <GenericDialog
      isOpen={checkoutModal === "UNSERVICEABLE_PRODUCTS"}
      setIsOpen={() => setCheckoutModal("NONE")}
      translateAxis="y"
      dialogOverlay={true}
      customClass="overflow-scroll md:!top-auto md:absolute rounded-t-2xl max-h-fit"
      closeOnOverlayClick
      modalType="UNSERVICEABLE_PRODUCTS">
      <DialogBody className="!px-3 !pt-4 h-fit">
        <div className="flex flex-col">
          <h1 className="text-base font-medium text-carbon-dark mb-3">{t('item_in_cannot_be_delivered')}</h1>
          <div className="flex flex-col gap-2">
            <OrderSummaryErrorCustom customErrorMessage={errorTitle} />
            <CheckoutItems items={unservicableItems} isUnservicable checkoutItemsMutable={false} />
          </div>
        </div>
      </DialogBody>

      <DialogFooter>
        <PrimaryButton
          isLoading={isLoading}
          buttonText={areAllProductsUnservicable ? t("go_back_to_store") : t("remove_unservicable_items")}
          onClick={handleRemoveUnservicableItems}
          height="h-14"
          isCheckout={false}
        />
      </DialogFooter>
    </GenericDialog>
  );
};
